import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { Link } from 'components/Link/Link';

type Props = {
  destinationUrl: string;
  displayText: string;
  refTags: any;
};

export const CustomAhref = ({
  destinationUrl,
  displayText,
  refTags,
}: Props) => {
  return (
    <Link href={destinationUrl} rel={refTags as string}>
      <LinkText>{displayText}</LinkText>
    </Link>
  );
};

const LinkText = styled.span`
  color: ${Colors.blueJeans};
  font-size: 16px;
  font-weight: 600;
  line-height: 175%;
  text-decoration: underline;
  ${mediaQueries.desktop} {
    font-size: 19px;
  }

  &:hover,
  :focus,
  :focus-within {
    color: ${Colors.blueJeans};
  }
`;
